<template>
    <div>
        <card class="mb-5">
            <template slot="body">
                <h6 class="heading-small text-muted">Appointment Schedule</h6>
                <div class="row pb-3">
                    <div class="col-lg-6 col-sm-12">
                        <form-select
                            placeholder="Booking Type"
                            label="Booking Type"
                            v-model="form.booking_type"
                            :options="bookingTypes"
                            ref="is_home"
                        ></form-select>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form-date-picker time
                            format="MMMM DD, YYYY hh:mm a"
                            label="Appointment Date and Time"
                            placeholder="datetime"
                            v-model="form.datetime"
                            :min-date="minDate"
                            ref="datetime"
                        ></form-date-picker>
                    </div>
                </div>
                <h6 class="heading-small text-muted">Address Information</h6>
                <div class="row pb-3">
                    <div class="col-lg-12 mb-4">
                        <google-map disabled :initial-location="initialAddress.position" :initial-value="initialAddress" ref="map"></google-map>
                    </div>
                    <div class="col-lg-12">
                        <div class="row">
                            <div v-if="isLoggedIn" class="col-sm-12">
                                <modal-selector
                                    title="Select an address"
                                    label="Address"
                                    placeholder="Select an address"
                                    :fetch-link="addressFetchLink"
                                    paginate-path="data.result.addresses"
                                    display-key="name"
                                    sub-name-key="display_name"
                                    v-model="selectedAddress"
                                    @change="updatedSelectedAddress"
                                    style="width: calc(100% - 160px);" class="inline-block"
                                    ref="address"
                                >
                                </modal-selector>
                                <button class="btn mt--1 ml-2 verification-button" type="button" @click="$refs.addressCreateForm.show()">
                                    <i class="fa fa-plus mr-2"></i> Add address
                                </button>
                            </div>
                            <div v-else class="col-sm-12">
                                <button class="btn mt--1 ml-2 verification-button float-right" type="button" @click="$refs.addressCreateForm.show()">
                                    <i class="fa fa-search mr-2"></i> Search address
                                </button>
                            </div>
                            <div class="col-lg-11">
                                <div class="text-xs">Unit/House no, Building, Street name</div>
                                <h3 v-if="address.specification" class="font-weight-700 text-default text-sm" v-text="address.specification"></h3>
                                <h3 v-else class="font-weight-700 text-default text-sm text-muted">N/A</h3>
                            </div>
                            <div class="col-lg-11">
                                <div class="text-xs">Barangay</div>
                                <h3 v-if="address.barangay" class="font-weight-700 text-default text-sm" v-text="address.barangay"></h3>
                                <h3 v-else class="font-weight-700 text-default text-sm text-muted">N/A</h3>
                            </div>
                            <div class="col-lg-6 col-sm-12">
                                <div class="text-xs">City/Municipality</div>
                                <h3 v-if="address.city" class="font-weight-700 text-default text-sm" v-text="address.city"></h3>
                                <h3 v-else class="font-weight-700 text-default text-sm text-muted">N/A</h3>
                            </div>
                            <div class="col-lg-5 col-sm-12">
                                <div class="text-xs">Province</div>
                                <h3 v-if="address.province" class="font-weight-700 text-default text-sm" v-text="address.province"></h3>
                                <h3 v-else class="font-weight-700 text-default text-sm text-muted">N/A</h3>
                            </div>
                            <div class="col-lg-6">
                                <div class="text-xs">Zipcode</div>
                                <h3 v-if="address.zipcode" class="font-weight-700 text-default text-sm" v-text="address.zipcode"></h3>
                                <h3 v-else class="font-weight-700 text-default text-sm text-muted">N/A</h3>
                            </div>
                            <div class="col-12">
                                <button v-if="selectedAddress != null" class="btn btn-warning float-right" @click="save">
                                    Next <i class="fas fa-angle-right ml-2"></i>
                                </button>
                                <button v-else class="btn btn-warning float-right disabled" disabled>
                                    Next <i class="fas fa-angle-right ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </card>
        <booking-address-create-form ref="addressCreateForm" @created="addressCreated" />
    </div>
</template>
<script>
import '@styles/table.css';
import moment from "moment";
import { route } from '@utils/network';
import mixins from "@utils/mixins";
import ModalSelector from "@components/forms/selects/modal-selector/ModalSelector";
import BookingAddressCreateForm from "./BookingAddressCreateForm";

export default {
    name: "ShopSearchSection",

    components: { ModalSelector, BookingAddressCreateForm },

    computed: {
        initialData() {
            return this.$store.getters.shopSearchForm;
        },
        minDate() {
            return moment().add(2, "hours").format("MMMM DD, YYYY hh:mm A");
        },
        timezoneOffset() {
            return new Date().getTimezoneOffset() / 60;
        },
        isLoggedIn() {
            return this.$store.getters.userToken != null;
        },
        initialAddress() {
            return {
                address: { ...this.address },
                position: {
                    lat: parseFloat(this.address.latitude || 14.5995124),
                    lng: parseFloat(this.address.longitude || 120.9842195),
                    radius: 0,
                }
            };
        },
    },

    data: () => ({
        address: {},
        selectedAddress: null,
        addressFetchLink: route("shop-search-addresses"),
        form: {
            booking_type: "in-shop",
            datetime: moment().add(2, "hours").format("MMMM DD, YYYY hh:mm A"),
            latitude: 14.8527252,
            longitude: 120.8160598,
            radius: 5,
        },
        bookingTypes: [
            { text: "Home", value: "home" },
            { text: "In Shop", value: "in-shop" }
        ],
    }),
    
    methods: {
        updatedSelectedAddress(address) {
            this.address = address,
            this.form.longitude = address.longitude;
            this.form.latitude = address.latitude;
            this.$nextTick(() => this.$refs.map.resetMarkers());
        },
        save() {
            
            this.$store.dispatch("setShopSearchParams", {
                ...this.form,
                is_home: this.form.booking_type == "home" ? 1 : 0,
                datetime: moment(this.form.datetime).add(this.timezoneOffset, "hour").format("MMMM DD, YYYY hh:mm a"),
            });
            this.$store.dispatch("setAddress", this.address);

            this.$emit("next");
        },

        handleErrors(error) {
            console.log(error);
            this.promptFormErrors(this.$refs, error);
        },
        initializeData() {
            this.form = this.initialData.form ? {
                ...this.initialData.form,
                datetime: moment(this.form.datetime).subtract(this.timezoneOffset, "hour").format("MMMM DD, YYYY hh:mm a"),
            } : this.form;
            this.address = this.initialData.address ? { ...this.initialData.address } : this.address;
            this.initializeAddressSelector(this.initialData.address ? (this.initialData.address.id || this.initialData.address) : this.selectedAddress);
        },
        initializeAddressSelector(address) {
            if (!address) return;
            this.selectedAddress = address;
            if (this.isLoggedIn) {
                this.$nextTick(() => this.$refs.address.search([this.selectedAddress]));
            }
        },
        addressCreated(address) {
            this.updatedSelectedAddress(address);
            this.initializeAddressSelector(this.isLoggedIn ? address.id : address);
        }
    },

    mixins: [mixins],

    mounted() {
        this.initializeData();
    },

}
</script>